import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-edit-user-dialog',
  standalone: true,
  imports: [MatDialogModule, CommonModule, MatButtonModule, ButtonComponent, FormsModule, NgMultiSelectDropDownModule],
  templateUrl: './edit-user-dialog.component.html',
  styleUrl: './edit-user-dialog.component.scss'
})
export class EditUserDialogComponent {

  rolesList: any = [
    {
      role_id: 1, role_name: 'admin'
    },
    {
      role_id: 3, role_name: 'creator'
    },
    {
      role_id: 2, role_name: 'curator'
    },
    {
      role_id: 4, role_name: 'user'
    }
  ];
  // categories: any;
  dropdownSettings: IDropdownSettings = {};
  categoryDropdownList: any = [];
  selectedCategoryItems: any = [];
  selectedRole: string = '';
  originalData: any;
  isCatvalid:boolean = false;
  
  selectedCategoryUsersIds: any;

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialogRef: MatDialogRef<EditUserDialogComponent>,
    ) {
     
      this.originalData = JSON.parse(JSON.stringify(this.data));
      // this.roles = data?.role;
      this.categoryDropdownList = data?.categoryDropdownList;
    }

    ngOnInit() {
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
      };
      if(this.data && this.data.role_name) {
        this.selectedRole = this.data?.role_name;
      }

      if (this.data && this.data.user_category.length) {
        this.selectedCategoryItems = this.data?.user_category;
        this.selectedCategoryUsersIds = this.data.user_category.map((item:any) => item.id);
   
        
      }
    }

    onCategoryItemSelect(e:any) {
    
    }
    
    roleItemChange(e:any) {
      this.isCatvalid = false;
    }

    close() {
      this.dialogRef.close();
    }

    updateUser() {
     
      if(!this.selectedRole) {
        return;
      }

      if(this.selectedRole === 'curator' && !this.selectedCategoryItems.length) {
        this.isCatvalid = true;
        return;
      }
      this.isCatvalid = false;
      let selectedCategoriesIds = this.selectedCategoryItems.map((category:any) => category.id);
      const selectedRoleObj = this.rolesList.find((role:any) => role.role_name === this.selectedRole);
     
      
      const selectedRole_id = selectedRoleObj.role_id ? selectedRoleObj.role_id : null;

      const assignedCategoryIds = this.data?.user_category.map((category: any) => category.id);
      const categoryIdsToAssign = selectedRole_id === 2 ? selectedCategoriesIds.filter((id: any) => !assignedCategoryIds.includes(id)) : [];
      
      const idRemoves = this.data?.user_category.filter((id:any) => !selectedCategoriesIds?.includes(id.id));
      const removedCatIds = idRemoves.length > 0 ? idRemoves?.map((item:any) => item.id) : []; 

      const postData = {
        user_ids: [this.data?.id],
        category_ids_assign: categoryIdsToAssign,
        category_ids_remove: selectedRole_id == 2 && idRemoves.length > 0 ? removedCatIds : [],
        role_id: selectedRole_id
      }
      
      if(postData.category_ids_assign.length || postData.category_ids_remove.length || postData.role_id) {
        
        
        this.dialogRef.close(postData);
      } else {
        this.dialogRef.close();
      }
    }
}
